/*
 * Module for the Insurance edit view
*/
rs.module("content/system/configuration/availablepaycomponent/paycomponenttab",

    ["common/select-helper"],

    function (selectHelper) {

        //
        // Initialize
        //
        function initialize(jsSelectors, codeValues) {
            var payComponentTabForm = $.js(jsSelectors.payComponentTabForm);

            var individualVendorsCheckbox = payComponentTabForm.js(jsSelectors.individualVendorsCheckbox);
            var vendorSelector = payComponentTabForm.js(jsSelectors.vendorSelector);
            var vendorSelectHelper = selectHelper.getHelper(vendorSelector);

            // enable/disable vendor selector when individual vendor checkbox changes
            individualVendorsCheckbox.change(function () {
                vendorSelectHelper.setDisabled(this.checked);

                if (this.checked) {
                    vendorSelectHelper.setValue(null);
                    hiddenVendorSelector.setValue(null);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);